module.exports = __webpack_public_path__ + "img/logo.c2a42625.png";